import React from "react";

const SearchIcon = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 41 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.5702 18.3219L33.5703 18.3201C33.9929 13.8837 32.5855 9.51348 29.6911 6.05436C26.7993 2.59828 22.7825 0.483618 18.2675 0.0597566C9.10055 -0.714663 0.85223 6.12794 0.0770455 15.3597L0.0765775 15.3653H0.0765465C-0.346403 19.8063 0.99182 24.1743 3.88128 27.6288C6.84761 31.0883 10.8663 33.202 15.3796 33.6256C24.5431 34.3997 32.7239 27.56 33.5702 18.3219ZM25.8884 9.33903L25.8883 9.33909C27.8538 11.7582 28.8432 14.7917 28.5392 17.9078C28.2363 21.0122 26.7954 23.8193 24.3705 25.8653C21.9499 27.9077 18.8408 28.899 15.7225 28.5223C12.5347 28.2912 9.7308 26.7699 7.69192 24.3534L7.68594 24.3463H7.68601C5.72126 21.9281 4.7319 18.8961 5.03475 15.7814C5.56809 9.33032 11.3324 4.55965 17.8446 5.16254C21.0354 5.39193 23.842 6.91367 25.8824 9.33195L25.8884 9.33903Z"
      transform="translate(6.355 1)"
      fill="#F8FAFC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.5702 18.3219L33.5703 18.3201C33.9929 13.8837 32.5855 9.51348 29.6911 6.05436C26.7993 2.59828 22.7825 0.483618 18.2675 0.0597566C9.10055 -0.714663 0.85223 6.12794 0.0770455 15.3597L0.0765775 15.3653H0.0765465C-0.346403 19.8063 0.99182 24.1743 3.88128 27.6288C6.84761 31.0883 10.8663 33.202 15.3796 33.6256C24.5431 34.3997 32.7239 27.56 33.5702 18.3219ZM25.8884 9.33903L25.8883 9.33909C27.8538 11.7582 28.8432 14.7917 28.5392 17.9078C28.2363 21.0122 26.7954 23.8193 24.3705 25.8653C21.9499 27.9077 18.8408 28.899 15.7225 28.5223C12.5347 28.2912 9.7308 26.7699 7.69192 24.3534L7.68594 24.3463H7.68601C5.72126 21.9281 4.7319 18.8961 5.03475 15.7814C5.56809 9.33032 11.3324 4.55965 17.8446 5.16254C21.0354 5.39193 23.842 6.91367 25.8824 9.33195L25.8884 9.33903Z"
      transform="translate(6.355 1)"
      stroke="#606F7B"
      strokeMiterlimit="8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.93106 10.0798C-0.227531 11.2384 -0.282048 12.8791 0.64063 13.8018C1.56331 14.7245 3.20409 14.67 4.36268 13.5114L13.5114 4.36267C14.67 3.20407 14.7245 1.56329 13.8018 0.640623C12.8792 -0.282054 11.2384 -0.227524 10.0798 0.931073L9.73413 0.585373L10.0798 0.931073L0.93106 10.0798Z"
      transform="translate(1 26.85)"
      fill="#F8FAFC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.93106 10.0798C-0.227531 11.2384 -0.282048 12.8791 0.64063 13.8018C1.56331 14.7245 3.20409 14.67 4.36268 13.5114L13.5114 4.36267C14.67 3.20407 14.7245 1.56329 13.8018 0.640623C12.8792 -0.282054 11.2384 -0.227524 10.0798 0.931073L9.73413 0.585373L10.0798 0.931073L0.93106 10.0798Z"
      transform="translate(1 26.85)"
      stroke="#606F7B"
      strokeMiterlimit="8"
    />
  </svg>
);

export default SearchIcon;



// WEBPACK FOOTER //
// ../shop_main/images/searchIcon.js